import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ShareddtaService } from './shareddta.service';

@Injectable({
  providedIn: 'root'
})
export class WebsocketrecivingService {
  private socket: WebSocket | undefined;
  port = environment.port;
  private connectionStatus: boolean = false;
  private messageHandler: ((event: MessageEvent) => void) | undefined;
  private manuallyDisconnected: boolean = false; // Flag to track manual disconnection

  constructor(public ShareddtaServices: ShareddtaService) {
    this.setupOnlineOfflineListeners();
  }

  // Manually trigger a WebSocket connection
  public connect() {
    this.manuallyDisconnected = false;
    if (this.connectionStatus || this.manuallyDisconnected) {
      console.log('reciving web socket connected');
      return;
    }
    this.connection();
    console.log('reciving web socket connected');
  }

  // Manually disconnect the WebSocket
  public disconnect() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      console.log('Manually disconnecting WebSocket...');
      this.manuallyDisconnected = true; // Set flag to prevent auto-reconnect
      this.socket.close();
    }
  }

  private connection() {
    this.manuallyDisconnected =true;
    let additionalParam = localStorage.getItem('schema_name');
    let additionalParam1 = localStorage.getItem('org_domain');

    if (!additionalParam1) {
      console.error('org_domain is null');
      return;
    }

    const url = new URL(additionalParam1);
    const hostname = url.hostname;

    this.socket = new WebSocket(`wss://${hostname}:${this.port}/ws/receiving-company-track-order/${additionalParam}/`);

    this.socket.onopen = () => {
      this.connectionStatus = true;
      this.manuallyDisconnected = false; // Reset flag on successful connection
      console.log('Connection established:', this.connectionStatus);

      // Reassign the onmessage event handler with the stored callback function, if available
      if (this.messageHandler) {
        this.socket!.onmessage = this.messageHandler;
      }
    };

    this.socket.onclose = () => {
      this.connectionStatus = false;
      console.log('Connection closed:', this.connectionStatus);
      if (!this.manuallyDisconnected) {
        // Reconnect only if the disconnection was not manual
        this.reconnect();
      }
    };

    const messageHandler = (event: MessageEvent) => {
    //  console.log('Received data:', event.data);
      this.handleReceivedData(event.data);
    };

    // Store the callback function
    this.messageHandler = messageHandler;

    this.socket.onmessage = messageHandler;
  }

  private handleReceivedData(data: any): void {
    // Implement your logic to handle the received data
    console.log('Handling received data:', data);

    // For example, you can emit the data through an Observable or call a function in another service
    this.ShareddtaServices.updateData(data);
  }

  private setupOnlineOfflineListeners() {
    window.addEventListener('online', () => {
      console.log('Online');
      if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
        console.log('Reconnecting WebSocket...');
        if (!this.manuallyDisconnected) {
          this.connection();
        }
      }
    });

    window.addEventListener('offline', () => {
      console.log('Offline');
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        console.log('Closing WebSocket due to offline status...');
        this.socket.close();
      }
    });
  }

  private reconnect() {
    setTimeout(() => {
      if (!this.socket || this.socket.readyState === WebSocket.CLOSED) {
        console.log('Attempting to reconnect...');
        if (!this.manuallyDisconnected) {
          this.connection();
        }
      }
    }, 3000); // Try reconnecting after 3 seconds
  }

  public receiveData(callback: (data: any) => void): void {
    if (!this.socket) {
      console.error('WebSocket connection is not established.');
      return;
    }

    // This method should ideally store the callback and reassign it during reconnection
    // But for simplicity, we've handled this logic in the connection() method
  }
}
